<div class="cart" id="cart" [hidden]="!items.count && !getScreenWidth">
    <button (click)="showCart = !showCart">
        <div class="budget">{{ items.count }}</div>
        <figure>
            <img src="assets/images/ico-carrinho.svg">
        </figure>
    </button>
<!--    <my-portal-popover-cart *ngIf="items.count" [items]="items" [showCartEvent]="showCart" (cartItems)="updateCart($event)"></my-portal-popover-cart>-->
</div>
